export type FormAfterSaveActionResult = Promise<{ continue: boolean }>;
export type FormAfterSaveAction = () => FormAfterSaveActionResult;

export async function runFormAfterSaveActions(steps: FormAfterSaveAction[]): Promise<boolean> {
	for (const step of steps) {
		const result = await step();
		if (!result.continue) return false;
	}
	return true;
}